import Dictionary from "~/ts/library/Dictionary";

export const BRAND_VERBOX = "verbox";
export const BRAND_TALKME = "talk-me";
export const BRAND_METALK = "me-talk";
export const BRAND_ONLINE_CHAT = "online-chat";

export interface OperatorApplicationBrandInterface {
    id: string;
    descr: string;
}

export const OPERATOR_APPLICATION_BRANDS: Dictionary<OperatorApplicationBrandInterface> = {
    [BRAND_VERBOX]: {
        id: BRAND_VERBOX,
        descr: "Verbox"
    },
    [BRAND_TALKME]: {
        id: BRAND_TALKME,
        descr: "Talk-Me"
    },
    [BRAND_METALK]: {
        id: BRAND_METALK,
        descr: "Me-Talk"
    },
    [BRAND_ONLINE_CHAT]: {
        id: BRAND_ONLINE_CHAT,
        descr: "Online-Chat"
    },
}